module.exports = __webpack_public_path__ + "media/terrace.5992ceed.svg";